import { useParams } from 'react-router-dom';
import { ShowPageLayout, EntityHeader } from 'framework/ui/layout';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { useDocumentStorageContext } from 'framework/documentStorage';
import DocumentPreviewContent from './DocumentPreviewContent';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';

const DocumentPreviewPage = () => {
  const { documentName } = useParams();
  const { addMessage } = useMessageService();
  const { getDocumentByPaths } = useDocumentStorageContext();

  const decodedDocumentPath = decodeURIComponent(documentName!);

  const getShowData = async () => {
    try {
      const documentData = (await getDocumentByPaths([decodedDocumentPath]))[0];

      return {
        documentPath: decodedDocumentPath,
        ...documentData,
        createdAt: documentData.metadata?.createdAt,
        fileName: documentData.metadata?.fileName,
        office: documentData.metadata?.office,
        section: documentData.metadata?.section,
        fileType: documentData.metadata?.fileType,
        internalId: documentData.metadata?.internalId,
        templateId: documentData.metadata?.templateId,
      };
    } catch (error) {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
      return {
        documentPath: decodedDocumentPath,
        hasError: true,
      };
    }
  };

  return (
    <FormShowTemplate getDataFunc={getShowData} submitFormFunc={async () => {}}>
      <ShowPageLayout
        entityHeader={<EntityHeader hasAuthor={false} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />}
        hasSeparateSections
      >
        <DocumentPreviewContent />
      </ShowPageLayout>
    </FormShowTemplate>
  );
};

export default DocumentPreviewPage;
